const devUrl = 'http://localhost:5000/api/'; // eslint-disable-line no-unused-vars
const stagingUrl = 'https://roomsign-staging.hypersign.net/api/'; // eslint-disable-line no-unused-vars
export const mainUrl = "https://roomsign.hypersign.net/api/"



// WEBPACK FOOTER //
// ./src/Constants.js